import React, { useContext } from 'react';

import { AppContext } from '../../capabilities/contextStore/AppContext';
import { CCGThemeProviderContext } from '../../capabilities/contextStore/CCGThemeProviderContext';
import {
  getHeaderLogoVisibility,
  getHideApplicationLanguageSelector,
} from '../../utils/session/appearance/selectors';

import Header from './Header';

const ConditionalHeader = () => {
  const {
    hasInitialSessionDataLoaded,
    originalCheckoutSessionResponse,
  } = useContext(AppContext);

  const { appearance } = useContext(CCGThemeProviderContext);

  /**
   * If hasInitialSessionDataLoaded is true then it should be safe to use the appearance
   * object because it should not get updated from the server after the initial session details call.
   * So, with hasInitialSessionDataLoaded as a guard we can rerender this component and
   * expect it to produce the same result (whether to show the header or not).
   * Also, we don't load the header if there are errors in the session, we can check this by
   * seeing if the originalCheckoutSessionResponse is populated.
   */

  const sessionHasLoadedWithoutErrors = Boolean(
    hasInitialSessionDataLoaded &&
      originalCheckoutSessionResponse &&
      Object.keys(originalCheckoutSessionResponse).length,
  );

  let showLogo = true;
  let hideApplicationLanguageSelector = false;

  if (!hasInitialSessionDataLoaded) {
    hideApplicationLanguageSelector = true;
  }

  if (sessionHasLoadedWithoutErrors && appearance) {
    showLogo = getHeaderLogoVisibility(appearance);
    hideApplicationLanguageSelector =
      getHideApplicationLanguageSelector(appearance);
  }

  if (!sessionHasLoadedWithoutErrors) {
    showLogo = false;
  }

  if (!showLogo && hideApplicationLanguageSelector) {
    return null; // Do not render the header if both are hidden
  }

  return (
    <Header
      showLogo={showLogo}
      hideApplicationLanguageSelector={
        hideApplicationLanguageSelector
      }
    />
  );
};

export default ConditionalHeader;
